/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentRequest } from './DocumentRequest';
import {
    DocumentRequestFromJSON,
    DocumentRequestFromJSONTyped,
    DocumentRequestToJSON,
    DocumentRequestToJSONTyped,
} from './DocumentRequest';

/**
 * 
 * @export
 * @interface DocumentOfferingRequest
 */
export interface DocumentOfferingRequest {
    /**
     * 
     * @type {Array<DocumentRequest>}
     * @memberof DocumentOfferingRequest
     */
    documentsOffering?: Array<DocumentRequest>;
}

/**
 * Check if a given object implements the DocumentOfferingRequest interface.
 */
export function instanceOfDocumentOfferingRequest(value: object): value is DocumentOfferingRequest {
    return true;
}

export function DocumentOfferingRequestFromJSON(json: any): DocumentOfferingRequest {
    return DocumentOfferingRequestFromJSONTyped(json, false);
}

export function DocumentOfferingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentOfferingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'documentsOffering': json['documentsOffering'] == null ? undefined : ((json['documentsOffering'] as Array<any>).map(DocumentRequestFromJSON)),
    };
}

export function DocumentOfferingRequestToJSON(json: any): DocumentOfferingRequest {
    return DocumentOfferingRequestToJSONTyped(json, false);
}

export function DocumentOfferingRequestToJSONTyped(value?: DocumentOfferingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentsOffering': value['documentsOffering'] == null ? undefined : ((value['documentsOffering'] as Array<any>).map(DocumentRequestToJSON)),
    };
}

